import { graphql } from 'gatsby';
import parse from 'html-react-parser';
import { TableWrapper, StyledFigCaption } from './Table.styles';

const Table = ({ tableElements: elements }: Queries.TABLEFragment) => {
  const description = elements.description?.value;
  const tableWidth = elements.table_width?.value;
  const hideHeaderRow = elements.header_row?.value;

  return (
    <TableWrapper tableWidth={tableWidth} hideHeaderRow={hideHeaderRow}>
      {parse(elements.table.value)}
      {Boolean(description) && <StyledFigCaption>{description}</StyledFigCaption>}
    </TableWrapper>
  );
};

export default Table;

export const fragments = graphql`
  fragment TABLE on kontent_item_table {
    __typename
    system {
      id
      codename
    }
    tableElements: elements {
      table {
        value
      }
      description {
        value
      }
      table_width {
        value
      }
      header_row {
        value
      }
    }
  }
`;
